import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Card, Row, Col, Space } from "antd";
import { CalculatorOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { trackFeatureUsage } from "../lib/posthog";

const { Title, Text } = Typography;

const ToolCard = styled(Card)`
  cursor: pointer;
  transition: all 0.3s;
  height: 100%;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
`;

const IconWrapper = styled.div`
  font-size: 24px;
  margin-bottom: 16px;
  color: #1890ff;
`;

export const Tools: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const toolsList = [
    {
      title: t("tools.lvbPalletCalculator.title"),
      description: t("tools.lvbPalletCalculator.description"),
      icon: <CalculatorOutlined />,
      path: "/tools/lvb-pallet-calculator",
      key: "lvb_pallet_calculator",
    },
    // HS Code Validator removed temporarily
    // More tools can be added here in the future
  ];

  const handleToolClick = (path: string, key: string) => {
    navigate(path);
    trackFeatureUsage(`tools_${key}`);
  };

  return (
    <div style={{ padding: 24 }}>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <Title level={2}>{t("common.tools")}</Title>

        <Row gutter={[24, 24]}>
          {toolsList.map((tool) => (
            <Col xs={24} sm={12} md={8} lg={6} key={tool.key}>
              <ToolCard
                onClick={() => handleToolClick(tool.path, tool.key)}
                hoverable
              >
                <IconWrapper>{tool.icon}</IconWrapper>
                <Title level={4}>{tool.title}</Title>
                <Text type="secondary">{tool.description}</Text>
              </ToolCard>
            </Col>
          ))}
        </Row>
      </Space>
    </div>
  );
};

export default Tools;
